import React from 'react';
import { Dialog, Typography, Box, Divider, Stack, DialogTitle, DialogContent } from '@mui/material';

import { Button } from '../../../../components/core';

interface ActionDialogModalProps {
  isOpen: boolean;
  onClose: () => void;
  onProceed?: () => void;
  isSubmitting?: boolean;
  content: {
    heading: string;
    helpingText?: string;
    cancelButtonText: string;
    proceedButtonText: string;
  };
}

export const ActionDialogModal = ({
  isOpen,
  onClose,
  content,
  onProceed,
  isSubmitting,
}: ActionDialogModalProps) => {
  return (
    <Dialog open={isOpen} onClose={onClose} PaperProps={{ sx: { borderRadius: 4 } }} maxWidth="sm">
      <DialogTitle sx={{ fontWeight: 600 }}>{content.heading}</DialogTitle>
      <DialogContent
        sx={{
          overflowX: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <Typography sx={{ fontWeight: 400, fontSize: '14px' }}>{content.helpingText}</Typography>
        <Box>
          <Divider sx={{ mb: 2, mt: 4 }} />
          <Stack direction="row" spacing={1} sx={{ '& button': { height: '50px' } }}>
            <Button
              theme="secondary"
              variant="outlined"
              text={content.cancelButtonText}
              onClick={onClose}
              data-testid="cancel_dialog"
              isFullWidth
            />
            <Button
              variant="contained"
              onClick={onProceed}
              disabled={isSubmitting}
              loading={isSubmitting}
              data-testid="proceed_dialog"
              text={content.proceedButtonText}
              isFullWidth
            />
          </Stack>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
